// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Relative Imports
import appActions from '../../actions/actions';
import businessModelActions from '../../actions/businessModel';
import userInfoActions from '../../actions/userInfo';
import ConfirmationPage from './ConfirmationPage';
import confirmationPageActions from '../../actions/confirmationPage';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', ''),
        systemId: get(state, 'userInfoDetails.userInfoMetadata.ipm.externalSystemId', ''),
        externalId: get(state, 'userInfoDetails.userInfoMetadata.ipm.externalId', ''),
        userInfo: get(state, 'userInfoDetails.userInfoMetadata', ''),
        showBusinessModelSwitch: get(state, 'confirmationPage.showBusinessModelSwitch', false),
        showSwitchSoftwareProvider: get(state, 'confirmationPage.showSwitchSoftwareProvider', true),
        businessModel: get(state, 'businessModel.advertiserBusinessModel', null),
        preferredBusinessModel: get(state, 'businessModel.preferredBusinessModel', null),
        userInfoError: get(state, 'userInfoDetails.errorKey', ''),
        businessModelError: get(state, 'businessModel.serviceError', ''),
        footerData: state.app.footerData,
        translations: state.app.translations,
        dyff: get(state, 'app.dyff', {})
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        userInfoActions: bindActionCreators(userInfoActions, dispatch),
        confirmationPageActions: bindActionCreators(confirmationPageActions, dispatch),
        businessModelActions: bindActionCreators(businessModelActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class ConfirmationPageContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleContinueSubmit = this.handleContinueSubmit.bind(this);
        this.handleBMXFlowSwitchSubmit = this.handleBMXFlowSwitchSubmit.bind(this);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.getBrandDataFromUserInfo = this.getBrandDataFromUserInfo.bind(this);
    }

    componentWillMount() {
        this.props.appActions.enableLoadOverLay(true);
        this.props.userInfoActions.getConfirmationPageInfo(); // Sources user metadata from Core API/PMX for accurate snapshot
    }

    componentDidUpdate(prevProps) {
        if (!this.props.dyff?.SHARED_IPM_BANKING_ENABLED) return;
        const hasUserInfo = this.props.systemId || this.props.externalId;
        const prevHadUserInfo = prevProps.systemId || prevProps.externalId;

        // Fetch business model info once systemId and externalId are available
        if (hasUserInfo && !prevHadUserInfo) {
            this.props.businessModelActions.getAdvertiserBusinessModel();
            this.props.businessModelActions.getPreferredBusinessModel(this.props.systemId);
        }

        const hasBusinessModelInfo = this.props.businessModel && this.props.preferredBusinessModel;
        const prevHadBusinessModelInfo = prevProps.businessModel && prevProps.preferredBusinessModel;

        // Determine whether to show BusinessModelSwitch once business model info is available
        if (hasBusinessModelInfo && !prevHadBusinessModelInfo) {
            this.props.confirmationPageActions.setBusinessModelSwitchChoice(
                this.props.businessModel,
                this.props.preferredBusinessModel
            );
        }
    }

    getBrandDataFromUserInfo() {
        const {userInfo, translations} = this.props;
        const languageCode = userInfo?.brand?.locale?.split('_')[0];
        return {
            "name": userInfo?.brand?.name,
            "locale": translations[`ipmob.confirmation.banking.language.${languageCode}`],
            "domain": userInfo?.brand?.domain,
            "currencies": [userInfo?.billingCurrencyCode]
        };
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'ConfirmationPage');
    }

    handleAlertDismiss() {
        this.props.userInfoActions.alertError('');
        this.props.businessModelActions.alertError('');
    }

    handleContinueSubmit(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});
        this.props.confirmationPageActions.updateOnboardingStatus();
    }

    handleBMXFlowSwitchSubmit(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'ChangeBusinessModel'
        }, {});
        this.props.confirmationPageActions.updateOnboardingStatusToBMXIdentified();
    }

    render() {
        return (
            <ConfirmationPage
                publicUuid={this.props.publicUuid}
                translations={this.props.translations}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                systemId={this.props.systemId}
                externalId={this.props.externalId}
                handleContinueSubmit={this.handleContinueSubmit}
                handleBMXFlowSwitchSubmit={this.handleBMXFlowSwitchSubmit}
                showBankingConfirmationPage={this.props.dyff?.SHARED_IPM_BANKING_ENABLED}
                footerData={this.props.footerData}
                showBusinessModelSwitch={this.props.showBusinessModelSwitch}
                showSwitchSoftwareProvider={this.props.showSwitchSoftwareProvider}
                businessModel={this.props.businessModel}
                serviceError={this.props.userInfoError || this.props.businessModelError}
                handleAlertDismiss={this.handleAlertDismiss}
                brandData={this.getBrandDataFromUserInfo()}
            />
        );
    }
}

ConfirmationPageContainer.propTypes = {
    publicUuid: PropTypes.string,
    systemId: PropTypes.string,
    externalId: PropTypes.string,
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
};
